import React, { useEffect, useState } from 'react';

function Education() {
  const [education, setEducation] = useState([]);

  useEffect(() => {
    fetch('https://api.virajpargaonkar.me/api/education')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch education');
        return res.json();
      })
      .then((data) => {
        setEducation(data);
      })
      .catch((err) => {
        console.error(err);
        setEducation([]);
      });
  }, []);

  return (
    <>
      <section className="page-banner">
        <div className="container">
          <h1>Education</h1>
          <p>My academic background and qualifications.</p>
        </div>
      </section>
      <main className="page-content">
        <div className="container">
          {education.map((ed) => (
            <div className="education-item" key={ed.id} data-aos="fade-up">
              <h3>{ed.degree}</h3>
              <div className="education-meta">
                <span className="institution">{ed.institution}</span>{' '}
                <span className="dates">({ed.startYear} – {ed.endYear})</span>
              </div>
              {ed.details && <p>{ed.details}</p>}
            </div>
          ))}
        </div>
      </main>
    </>
  );
}

export default Education;